"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var contests_core_1 = require("@biw/contests-core");
var fetchProgramViewProgress = contests_core_1.progress.actions.fetchProgramViewProgress;
var getProgramViews = contests_core_1.programs.actions.getProgramViews;
exports.mapStateToProps = function (state) { return ({
    programs: contests_core_1.programs.selectors.getProgramViews(state)
}); };
exports.mapDispatchToProps = { fetchProgramViewProgress: fetchProgramViewProgress, getProgramViews: getProgramViews };
exports.default = react_redux_1.connect(exports.mapStateToProps, exports.mapDispatchToProps);
//# sourceMappingURL=connect.js.map